export const MESSAGE_TYPE = {
    ERROR: 1,
    SUCCESS: 2,
    CANCELED: 3,
};

export const IE_FREQUENCY_TYPE = [
    { Id: 'Weekly', Name: 'FREQUENCY_TYPES.WEEKLY' },
    { Id: 'Fortnightly', Name: 'FREQUENCY_TYPES.FORTNIGHTLY' },
    { Id: 'Monthly', Name: 'FREQUENCY_TYPES.MONTHLY' },
    { Id: 'Quarterly', Name: 'FREQUENCY_TYPES.QUARTERLY' },
    { Id: 'Annually', Name: 'FREQUENCY_TYPES.ANNUALLY' },
];

export const FINANCIAL_FREQUENCIES = {
    WEEKLY: 'Weekly',
    FORTNIGHTLY: 'Fortnightly',
    FOURWEEKLY: 'Fourweekly',
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    ANNUALLY: 'Annually'
};

export const ROUNDING_MODEL = {
    ROUND_DOWN: 0,
    ROUND_UP: 1,
    BANKERS_ROUNDING: 2
};